<nav class="navbar navbar-expand-lg bg-white py-3 sticky-header" [class.hidden]="isHidden" data-bs-theme="dark">
  <div class="container-lg d-flex justify-content-between ">
    <a routerLink="/home"><img src="../../../assets/img/logoo.svg" alt="registered" class="cursor-pointer btn"
        class="header-img"></a>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 text-white">
        <!-- <li class="nav-item mx-4">
          <a class="nav-link " aria-current="page" routerLink="/home" routerLinkActive="change_page">Home</a>
        </li> -->
        <li class="nav-item mx-4">
          <a class="nav-link hover:text-success" aria-current="page" routerLink="/pricing" routerLinkActive="change_page">Pricing</a>
        </li>
        <li class="nav-item dropdown mx-4">
          <a class="nav-link dropdown-toggle hover:text-success" role="button" [class.change_page]="isChildActive('/feature/')">
            Feature
          </a>
          <ul class="dropdown-menu">
            <li class="px-2"><a class="dropdown-item py-2" routerLink="/feature/broadcasting">WhatsApp Broadcasting</a>
            </li>
            <li class="px-2"><a class="dropdown-item py-2" routerLink="/feature/chat-bots">WhatsApp Chatbots</a></li>
            <li class="px-2"><a class="dropdown-item py-2" routerLink="/feature/click-tracking">WhatsApp Click
                Tracking</a></li>
          </ul>
        </li>
        <li class="nav-item mx-4">
          <a class="nav-link login-btn d-flex align-items-center gap-2" aria-current="page" href="https://www.app.getikk.com/login"><span>Login</span> <span class="material-symbols-outlined enable_toggle">
              enable
            </span></a>
        </li>
      </ul>
    </div>
    <div>
      <span class="text-muted d-flex d-lg-none" type="button" type="button" data-bs-toggle="offcanvas"
        data-bs-target="#staticBackdrop" aria-controls="staticBackdrop"><span class="material-symbols-outlined fs-1">
          menu
        </span></span>
    </div>
  </div>
</nav>

<div class="offcanvas offcanvas-end text-bg-dark" tabindex="-1" id="staticBackdrop"
  aria-labelledby="offcanvasDarkLabel">
  <div class="">
    <button type="button" class="btn-close btn-close-white m-2" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body ">
    <ul class="navbar-nav ms-auto mb-2 mb-lg-0 text-white">
      <li class="nav-item mx-4">
        <a class="nav-link text-success" aria-current="page" routerLink="/home" routerLinkActive="change_page"
          data-bs-dismiss="offcanvas">Home</a>
      </li>
      <li class="nav-item mx-4">
        <a class="nav-link text-success" aria-current="page" routerLink="/pricing" routerLinkActive="change_page"
          data-bs-dismiss="offcanvas">Pricing</a>
      </li>
      <li class="nav-item dropdown mx-4">
        <a class="nav-link dropdown-toggle text-success" role="button" [class.change_page]="isChildActive('/feature/')"
          data-bs-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false"
          aria-controls="collapseExample1">
          Feature
        </a>
        <ul class="collapse text-white" id="collapseExample1">
          <li class="text-white my-2 py-1"><a class="text-white" routerLinkActive="text-decoration-underline"
              routerLink="/feature/broadcasting" data-bs-dismiss="offcanvas">WhatsApp Broadcasting</a></li>
          <li class="text-white my-2 py-1"><a class="text-white" routerLinkActive="text-decoration-underline"
              routerLink="/feature/chat-bots" data-bs-dismiss="offcanvas">WhatsApp Chatbots</a></li>
          <li class="text-white my-2 py-1"><a class="text-white" routerLinkActive="text-decoration-underline"
              routerLink="/feature/click-tracking" data-bs-dismiss="offcanvas">WhatsApp Click Tracking</a></li>
        </ul>
      </li>
       <li class="nav-item mx-4">
        <a class="nav-link text-white" aria-current="page" href="https://www.app.getikk.com/login"
          >Login</a>
      </li>
    </ul>
  </div>
</div>